module.exports = __webpack_public_path__ + "static/bannerimage-e51be35984def6f23b5340ef3330fd7f.png";